import { createRouter, createWebHistory } from "vue-router";
import OtherMainView from "@/views/others/OtherMainView.vue";
import NWSettingMain from "@/views/nwSetting/NWSettingMain.vue";
import TopPage from "@/views/TopPage.vue";
import NotFoundView from "@/views/error/NotFoundView.vue";
import UserListView from "@/views/others/user/UserList.vue";
import VirtualNetworkListView from "@/views/nwSetting/virtualNetwork/VirtualNetworkList.vue";
import SaaSServiceApplicationListView from "@/views/nwSetting/saas/SaaSServiceApplicationList.vue";
import MSNaptSettingListView from "@/views/nwSetting/msNaptSetting/MSNaptSettingList.vue";
import NetworkErrorView from "@/views/error/NetworkErrorView.vue";
import SystemErrorView from "@/views/error/SystemErrorView.vue";
import SamlAuthFailedView from "@/views/error/SamlAuthFailedView.vue";
import SsoFailedView from "@/views/error/SsoFailedView.vue";
import SsoMultipleLoginView from "@/views/error/SsoMultipleLoginView.vue";
import MSNatSettingListView from "@/views/nwSetting/msNatSetting/MSNatSettingList.vue";
import IpSecGWList from "@/views/nwSetting/ipSecGw/IpSecGWList.vue";
import IpSecLineList from "@/views/nwSetting/ipSecLine/IpSecLineList.vue";
import AccessLineListView from "@/views/nwSetting/accessLine/AccessLineList.vue";
import QosSettingListView from "@/views/nwSetting/qos/QosSettingList.vue";
import CloudQosSettingListView from "@/views/nwSetting/cloudQos/CloudQosSettingList.vue";
import { store } from "@/store";
import Login from "@/views/Login.vue";
import SiteListView from "@/views/nwSetting/site/SiteList.vue";
import VNConnectListView from "@/views/nwSetting/vnConnect/VNConnectList.vue";
import HubAndSpokeListView from "@/views/nwSetting/hubAndSpoke/HubAndSpokeList.vue";
import { nextTick } from "vue";
import type { App } from "vue";
import CloudPacketFilteringList from "@/views/nwSetting/cloudPacketFiltering/CloudPacketFilteringList.vue";
import ExtranetConnectListView from "@/views/nwSetting/extranet/ExtranetConnectList.vue";
import PacketFilteringList from "@/views/nwSetting/packetFiltering/PacketFilteringList.vue";
import VNL2L3ConnectListView from "@/views/nwSetting/vnL2L3Connect/VNL2L3ConnectList.vue";
import NwInformationMain from "@/views/nwInformation/NwInformationMain.vue";
import OperationHistoryListView from "@/views/nwInformation/operationHistory/OperationHistoryList.vue";
import TrafficLogMain from "@/views/trafficLog/TrafficLogMainView.vue";
import TrafficSessionStatistics from "@/views/trafficLog/trafficSessionStatistics/TrafficSessionStatistics.vue";
import ContractLineListView from "@/views/nwInformation/contractLine/ContractLineList.vue";
import FailureMaintenanceList from "@/views/nwInformation/failureMaintenance/FailureMaintenanceList.vue";
import NotificationContactReferenceView from "@/views/others/notificationContact/NotificationContactReference.vue";
import AgreementHistoryList from "@/views/nwInformation/agreement/AgreementHistory.vue";
import MultiCloudListView from "@/views/nwSetting//multicloud/MultiCloudList.vue";
import ApplianceContractSettingList from "@/views/nwSetting/applianceContractSetting/ApplianceContractSettingList.vue";
import ApplianceObjectList from "@/views/nwSetting/applianceObject/ApplianceObjectList.vue";
import Type1SiteZoneList from "@/views/nwSetting/type1/Type1SiteZoneList.vue";
import Type4SiteList from "@/views/nwSetting/type4/Type4SiteList.vue";
import DownloadListView from "@/views/others/downloadList/DownloadList.vue";
import ContractSettingListView from "@/views/nwInformation/contractSettingLimit/ContractSettingList.vue";
import Cpa5gSaContractList from "@/views/nwSetting/cpa5gSa/Cpa5gSaContractList.vue";
import ApplianceLogList from "@/views/trafficLog/applianceLog/ApplianceLogList.vue";
import CpaAuthIdList from "@/views/trafficLog/cpaAuthId/CpaAuthIdList.vue";
import OneTimeUrlIssue from "@/views/password/OneTimeUrlIssue.vue";
import PasswordReset from "@/views/password/PasswordReset.vue";
import OneTimeUrlIssueComplete from "@/views/password/OneTimeUrlIssueComplete.vue";
import PasswordResetComplete from "@/views/password/PasswordResetComplete.vue";
import SaseGatewayListView from "@/views/nwSetting/saseGateway/SaseGatewayList.vue";
import saseGatewayPacketFilteringListView from "@/views/nwSetting/saseGatewayPacketFiltering/saseGatewayPacketFilteringList.vue";

export default {
  install: (app: App<Element>) => {
    const router = createRouter({
      history: createWebHistory(import.meta.env.BASE_URL),
      routes: [
        {
          path: "/",
          name: "MainView",
          component: () => import("@/views/Main.vue"),
          beforeEnter: (to, from, next) => {
            // ログインしていない場合はログイン画面へ遷移
            if (store.state.user.isLogged) {
              next();
            } else {
              next("/login");
            }
          },
          children: [
            { path: "", name: "TopPage", component: TopPage },
            // トラフィック/ログ
            {
              path: "",
              name: "TrafficLog",
              component: TrafficLogMain,
              children: [
                { path: "/report", component: TrafficSessionStatistics },
                { path: "/report/appliance-log", component: ApplianceLogList },
                {
                  path: "/report/remote/access/account",
                  component: CpaAuthIdList,
                },
              ],
            },
            // 各種設定
            {
              path: "",
              name: "otherMain",
              component: OtherMainView,
              children: [
                {
                  path: "/user",
                  name: "UserListView",
                  component: UserListView,
                },
                {
                  path: "/notification-contact",
                  name: "NotificationContactReferenceView",
                  component: NotificationContactReferenceView,
                },
                {
                  path: "/download",
                  name: "DownloadListView",
                  component: DownloadListView,
                },
              ],
            },
            // NW設定
            {
              path: "",
              name: "nwSettingMain",
              component: NWSettingMain,
              children: [
                // アクセス回線
                {
                  path: "/access",
                  name: "AccessLineListView",
                  component: AccessLineListView,
                },
                // 仮想ネットワーク設定
                {
                  path: "/vnetwork",
                  name: "VirtualNetworkListView",
                  component: VirtualNetworkListView,
                },
                {
                  path: "/vnetwork/qos",
                  name: "QosSettingListView",
                  component: QosSettingListView,
                },
                {
                  path: "/vnetwork/site",
                  name: "SiteListView",
                  component: SiteListView,
                },
                {
                  path: "/vnetwork/connect",
                  name: "VNConnectListView",
                  component: VNConnectListView,
                },
                {
                  path: "/vnetwork/packet-filtering",
                  name: "PacketListView",
                  component: PacketFilteringList,
                },
                // マルチクラウド
                {
                  path: "/multicloud",
                  name: "MultiCloudListView",
                  component: MultiCloudListView,
                },
                {
                  path: "/multicloud/saas",
                  name: "SaaSServiceApplicationListView",
                  component: SaaSServiceApplicationListView,
                },
                {
                  path: "/multicloud/microsoft/napt",
                  name: "MSNaptSettingListView",
                  component: MSNaptSettingListView,
                },
                {
                  path: "/multicloud/microsoft/nat",
                  name: "MSNatSettingListView",
                  component: MSNatSettingListView,
                },
                {
                  path: "/multicloud/qos",
                  name: "CloudQosSettingListView",
                  component: CloudQosSettingListView,
                },
                {
                  path: "/multicloud/packet-filtering",
                  name: "CloudPacketFilteringList",
                  component: CloudPacketFilteringList,
                },
                // SASEゲートウェイ
                {
                  path: "/sasegateway",
                  name: "SaseGatewayListView",
                  component: SaseGatewayListView,
                },
                // SASEゲートウェイ
                {
                  path: "/sasegateway/packet-filtering",
                  name: "SaseGatewayPacketFilteringListView",
                  component: saseGatewayPacketFilteringListView,
                },
                // IPsec回線
                {
                  path: "/ipsec/gateway",
                  name: "IpSecGWList",
                  component: IpSecGWList,
                },
                {
                  path: "/ipsec/line",
                  name: "IpSecLineList",
                  component: IpSecLineList,
                },
                // リモートアクセスGW
                {
                  path: "/remote/access",
                  name: "Cpa5gSaContractList",
                  component: Cpa5gSaContractList,
                },
                {
                  path: "/network/contract",
                  name: "contractView",
                  component: ApplianceContractSettingList,
                },
                // インターネット/アプライアンス
                {
                  path: "/network/site/type1",
                  name: "Type1SiteZoneList",
                  component: Type1SiteZoneList,
                },
                {
                  path: "/network/site/type4",
                  name: "Type4SiteList",
                  component: Type4SiteList,
                },
                // エクストラネット接続
                {
                  path: "/extranet",
                  name: "ExtranetConnectListView",
                  component: ExtranetConnectListView,
                },
                // Hub&Spoke接続
                {
                  path: "/hubspoke",
                  name: "HubAndSpokeListView",
                  component: HubAndSpokeListView,
                },
                // VN L2/L3コネクト
                {
                  path: "/vnetwork/l2l3/connect",
                  name: "VNL2L3ConnectListView",
                  component: VNL2L3ConnectListView,
                },
              ],
            },
            // マルチクラウド
            {
              path: "",
              name: "internetApplianceMain",
              component: NWSettingMain,
              children: [
                {
                  path: "/network/object",
                  name: "ApplianceObjectList",
                  component: ApplianceObjectList,
                },
              ],
            },
            // NW情報
            {
              path: "",
              name: "nwInformationMain",
              component: NwInformationMain,
              children: [
                {
                  path: "/info/contract/line",
                  name: "ContractLineListView",
                  component: ContractLineListView,
                },
                {
                  path: "/info/agreement/history",
                  name: "AgreementHistoryList",
                  component: AgreementHistoryList,
                },
                {
                  path: "/info/maintenance",
                  name: "FailureMaintenanceList",
                  component: FailureMaintenanceList,
                },
                {
                  path: "/info/operation/history",
                  name: "OperationHistoryListView",
                  component: OperationHistoryListView,
                },
                {
                  path: "/info/limit",
                  name: "ContractSettingList",
                  component: ContractSettingListView,
                },
              ],
            },
          ],
        },
        // 共通
        { path: "/login", component: Login },
        {
          path: "/password/reset",
          component: PasswordReset,
          props: (route) => ({
            identifykey: route.query.identifykey,
          }),
        },
        {
          path: "/password/one-time-url",
          component: OneTimeUrlIssue,
          props: (route) => ({
            expired: Array.isArray(route.query.expired)
              ? route.query.expired
              : route.query.expired?.toBoolean(),
            loginId: route.query.loginId,
          }),
        },
        {
          path: "/password/one-time-url/complete",
          component: OneTimeUrlIssueComplete,
        },
        { path: "/password/reset/complete", component: PasswordResetComplete },
        // エラー
        { path: "/system/error", component: SystemErrorView },
        { path: "/not-found", component: NotFoundView },
        { path: "/saml-auth/failed", component: SamlAuthFailedView },
        { path: "/single-sign-on/failed", component: SsoFailedView },
        {
          path: "/single-sign-on/multiple-login",
          component: SsoMultipleLoginView,
        },
        { path: "/network/error", component: NetworkErrorView },
        // 上記のいずれにも一致しない場合
        { path: "/:pathMatch(.*)*", redirect: "/not-found" },
      ],
    });
    // 画面移動時はモーダルを閉じる
    router.afterEach(() => {
      nextTick().then(async () => {
        await app.config.globalProperties.$vfm.closeAll();
      });
    });

    app.use(router);
  },
};
